/**
 * PHARMAKON — keyboard-layer overlays (WP-17): the F1 sheet and the command
 * palette. One store so the keys (F1, Ctrl+K through the dispatcher) and the
 * visible affordances (the topbar search pill, an « Aide » button) open the
 * same overlay. Nothing persisted.
 */
import { create } from "zustand";

export const useKeyboardStore = create((set) => ({
  helpOpen: false,
  paletteOpen: false,
  toggleHelp: () => set((s) => ({ helpOpen: !s.helpOpen })),
  openHelp: () => set({ helpOpen: true }),
  closeHelp: () => set({ helpOpen: false }),
  openPalette: () => set({ paletteOpen: true }),
  closePalette: () => set({ paletteOpen: false }),
}));

export default useKeyboardStore;
